module.exports = "<!-- <ion-view view-title=\"Record Progress\"> -->\n<ion-content>\n    <h1>Record Progress</h1>\n</ion-content>\n\n"